import React from "react";

import { Box, Button, Typography, Container, Paper } from "@mui/material";

import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #f4f7fb 0%, #eef4ff 40%, #ffffff 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* BACKGROUND CIRCLES */}

      <Box
        sx={{
          position: "absolute",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "rgba(25,118,210,0.08)",
          top: -120,
          left: -120,
          filter: "blur(10px)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "rgba(66,165,245,0.12)",
          bottom: -80,
          right: -80,
          filter: "blur(10px)",
        }}
      />

      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            borderRadius: 8,
            overflow: "hidden",
            background: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(255,255,255,0.6)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
          }}
        >
          <Box
            sx={{
              height: 8,
              background: "linear-gradient(90deg,#1976d2,#42a5f5,#90caf9)",
            }}
          />

          <Box
            sx={{
              py: {
                xs: 8,
                md: 10,
              },
              px: {
                xs: 3,
                md: 8,
              },
              textAlign: "center",
            }}
          >
            {/* ICON */}

            <Box
              sx={{
                width: 120,
                height: 120,
                borderRadius: "50%",
                background: "linear-gradient(135deg,#1976d2,#42a5f5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 4,
                boxShadow: "0 12px 30px rgba(25,118,210,0.35)",
              }}
            >
              <ErrorOutlineRoundedIcon
                sx={{
                  fontSize: 65,
                  color: "white",
                }}
              />
            </Box>

            {/* 404 */}

            <Typography
              sx={{
                fontSize: {
                  xs: 70,
                  md: 110,
                },
                fontWeight: 900,
                lineHeight: 1,
                background: "linear-gradient(135deg,#1976d2,#42a5f5)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                mb: 2,
              }}
            >
              404
            </Typography>

            {/* TITLE */}

            <Typography
              sx={{
                fontWeight: 800,
                fontSize: {
                  xs: 28,
                  md: 38,
                },
                color: "#1e293b",
                mb: 2,
              }}
            >
              Page Not Found
            </Typography>

            {/* DESCRIPTION */}

            <Typography
              sx={{
                maxWidth: 620,
                mx: "auto",
                color: "#64748b",
                fontSize: 16,
                lineHeight: 1.8,
                mb: 5,
              }}
            >
              The page you are looking for may have been removed, renamed, or is
              temporarily unavailable. Please check the URL or return to the
              main dashboard.
            </Typography>

            {/* ACTIONS */}

            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {/* BACK */}

              <Button
                variant="outlined"
                startIcon={<ArrowBackRoundedIcon />}
                onClick={() => navigate(-1)}
                sx={{
                  borderRadius: 4,
                  px: 4,
                  py: 1.4,
                  textTransform: "none",
                  fontWeight: 700,
                  borderWidth: 2,
                  borderColor: "#1976d2",
                  color: "#1976d2",

                  "&:hover": {
                    borderWidth: 2,
                    borderColor: "#1565c0",
                    background: "rgba(25,118,210,0.05)",
                  },
                }}
              >
                Go Back
              </Button>

              {/* HOME */}

              <Button
                variant="contained"
                startIcon={<HomeRoundedIcon />}
                onClick={() => navigate("/")}
                sx={{
                  borderRadius: 4,
                  px: 4,
                  py: 1.4,
                  textTransform: "none",
                  fontWeight: 700,
                  background: "linear-gradient(135deg,#1976d2,#42a5f5)",
                  boxShadow: "0 10px 25px rgba(25,118,210,0.35)",

                  "&:hover": {
                    background: "linear-gradient(135deg,#1565c0,#1e88e5)",
                    boxShadow: "0 14px 30px rgba(25,118,210,0.45)",
                  },
                }}
              >
                Return Home
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default NotFound;
